import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { isDefined } from "@grandvisionhq/utils";
import { useBrPageContext, useBrComponentContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachGroupCardsData = () => {
  const page = useBrPageContext();
  const component = useBrComponentContext();
  if (!component || !page) return void 0;
  const { pageable } = component.getModels();
  const params = component.getParameters();
  const cards = pageable?.items?.map((item) => {
    const cardContent = getBrPageContent(page, item);
    if (!cardContent) return void 0;
    const { content, link, title, card_image } = cardContent;
    return {
      content: content?.value ? parseHtml(content.value) : "",
      // Value is mandatory in Bloomreach
      urlText: link?.label,
      url: link?.url,
      header: title || "",
      // Value is mandatory in Bloomreach
      icon: card_image || ""
      // Value is mandatory in Bloomreach
    };
  }).filter(isDefined);
  return { cards, title: params.title };
};
export {
  useBloomreachGroupCardsData
};
//# sourceMappingURL=use-bloomreach-group-cards-data.js.map
